export default "/dc74ba5a53ae1ec40c17991bb2997797.jpg";